import { render, staticRenderFns } from "./NewsMasonryView.vue?vue&type=template&id=4d8dad3a&scoped=true&"
import script from "./NewsMasonryView.vue?vue&type=script&lang=js&"
export * from "./NewsMasonryView.vue?vue&type=script&lang=js&"
import style0 from "./NewsMasonryView.vue?vue&type=style&index=0&id=4d8dad3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8dad3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
